let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("ib2XA")).then(() => parcelRequire('8M6Qm'));